import axios from "axios";
import { miniappToken, clearAuthUser } from './miniappSession';

// Production serves the API and web app from the same origin. A missing build
// variable must never turn login requests into requests for "undefined/api".
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials: send/receive the httpOnly auth cookie on every request.
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const token = miniappToken();
  const backendOrigin = new URL(config.baseURL || API_BASE, window.location.href).origin;
  const destinationOrigin = /^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(config.url || '')
    ? new URL(config.url, window.location.href).origin : backendOrigin;
  if (token && backendOrigin === window.location.origin && destinationOrigin === window.location.origin) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const acct = localStorage.getItem("fishit_account");
  if (acct && !config.headers["X-Account-Id"]) {
    config.headers["X-Account-Id"] = acct;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Only redirect if we are not already on public pages
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/register") && path !== "/") {
        clearAuthUser();
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
